import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'

dayjs.extend(utc)
dayjs.extend(timezone)

export const formatMajorCityWeather = (pointIdList, data, now) => {
  if (pointIdList.length === 0) {
    return {}
  }

  const res = {}
  pointIdList
    .forEach((pointId) => {
      const pointData = data[pointId]
      const mrf = pointData.mrf
      res[pointId] = formatToday(mrf, now, pointData.timezone)
    })

  return res
}

const formatToday = (mrf, now, timezone) => {
  const nowInTz = dayjs.unix(now).tz(timezone)
  return mrf
    .map((item) => {
      const tm = dayjs.unix(item.utm).tz(timezone)
      const isHourlyTz = tm.minute() === 0
      const modifiedTm = isHourlyTz ? tm : tm.startOf('hour').add(1, 'hour')
      const isPast = modifiedTm.startOf('day').unix() < nowInTz.startOf('day').unix()
      return {
        ...item,
        past: isPast
      }
    })
    .filter((item) => !item.past)[0]
}
